import React, { Component } from "react";
import { withRouter } from "react-router";
import { Dropdown } from "react-bootstrap";
import moment from "moment";
import "./UI Component/Modal/Modal.css";
import "./MyTransactionsView/Transactions.scss";
import afterLoginApiAxios from "../Util/API Calls/afterLogin";
import Loader from "./UI Component/Loader/Loader";
import DocumentDoctor from "./DocumentDoctor";
import DocumentCotainer from "./UI Component/DocumentViewer/DocumentCotainer";
import PatientDetail from "./UI Component/PatientDetail/PatientDetail";
import swal from "sweetalert";
import { isMobile, isTablet } from "react-device-detect";
import CalendarIcon from "../assets/calendar.svg";
import newIcon from "../assets/newIcn.png";
import { filters } from "./DoctorComponents/DoctorMyPatients/constants";
import SelectedPatientsFilter from "./DoctorComponents/DoctorMyPatients/SelectedPatientsFilter";
import AppointmentPatientRow from "./AppointmentPatientRow";

import DrawerComponent from "./AppointmentHistory/DrawerComponent";
import RescheduleModal from "./DoctorDashboard/modal-reschedule";
import CancellationModal from "./DoctorDashboard/modal-cancellation";
import MarkNoShowModal from "./DoctorDashboard/modal-mark-noshow";
import CloseOngoingConsultModal from "./DoctorDashboard/modal-close-ongoing-consult";
import AppointmentScheduledModal from "./DoctorDashboard/modal-appointment-scheduled";
import FilterPatientsModal from "./DoctorComponents/DoctorMyPatients/FilterPatientsModal";
import Pagination from "./common/Pagination/Pagination";
import NoDataFound from "../assets/Nodata.svg";
import ViewDetailsModalNew from "./DoctorDashboard/modal-view-details-new";
import AppointmentJoinModal from "./DoctorDashboard/modal-appointment-join";
import AppointmentDateRangePicker from "./AppointmentHistory/AppointmentDateRangePicker";
import MarkCheckInModal from "./DoctorDashboard/modal-mark-check-in";
import { checkPermission } from "./ClinicComponents/CommonComponents/userPermission/userPermission";
import { APPLICABLE_STATUS } from "./DashboardAppointmentsView/Helper/actionsHelper";
import { LOCALSTORAGEKEY } from "../Util/Helper/localStorageUtils";
import { USER_TYPE } from "../Util/constants";
import { C2CConsole } from "../Util/Helper/C2CConsole";

class AppointmentPatient extends Component {
  constructor(props, context) {
    super(props, context);
    let appt = props.details;

    this.state = {
      datePickerType: "",
      appointments: [],
      activeDropDown: "initial",
      appointmentsTemp: [],
      appointmentDetails: appt,
      drawerOpen: false,
      drawerType: "",
      documentShow: false,
      fullView: false,
      setLgShow: false,
      show: false,
      statusName: "All",
      statusValue: "all",
      datavalue: "",
      selectedAppointmentType: false,
      filterValues: [],
      appointmentStatusName: "All",
      appointmentStatusValue: "all",
      appointmentDatas: [],
      appointmentForDrawer: {},
      appointment: null,
      showRescheduleModal: false,
      showCancellationModal: false,
      showRaiseInvoiceModal: false,
      showMarkNoShowModal: false,
      ongoingAppointment: {},
      showAppointmentScheduledModal: false,
      scheduledAppointment: {},
      setOpenView: false,
      appointment_id: null,
      status: {
        name: "All",
        value: "all",
      },
      state: "",
      startDate: "",
      endDate: "",
      markCheckInStartDate: "",
      markCheckInEndDate: "",
      activeIndex: 1,
      PageSize: 10,
      currentPage: 1,
      term: {
        search_string: "",
        sort_order: "all",
        status_filter: "all",
        appointment_filter: "all",
        consultation_filter: "all",
        page_number: 1,
      },
      showFilterComponent: false,
      appointmentStatusData: "all",
      appointmentDropDown: {
        value: "all",
        label: "All",
      },
      dateStatus: "",
      selectedStartDate: "",
      selectedEndDate: "",
      consultation_filter: "all",
      appointment_filter: "all",
      appointmentStatus: {
        name: "All",
        value: "all",
      },
      page_number: 1,
      records_per_page: 10,
      total_entries: null,
      total_pages_count: null,
      currentStatus: "",
      showJoinAppointmentModal: false,
      allDoctorsRelatedData: {
        name: "All",
        value: "all",
        doctor_id: this.props.temp_doctor_selected,
      },

      defaultDoctorIds: [],
      selectedDoctor: "all",
      selectedDoctorIds: [],
    };
  }
  doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  tokenId = localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN);

  openDatePicker(type) {
    this.setState({ datePickerType: type });
    this.setState({ show: !this.state.show });
  }

  componentDidMount() {
    this.fetchFirstTimeData();
    let filterValues = filters?.appointmentStatus;
    this.setState({ filterValues: filterValues });
  }

  fetchFirstTimeData = () => {
    this.getDoctorList();
  };

  getDoctorList = () => {
    if (this.userType === USER_TYPE.STAFF && !this.clinicId) {
      afterLoginApiAxios({
        method: "post",
        url: "/staff/get-complete-staff-info",
        headers: {
          "Content-Type": "application/json",
          Authorization: this.tokenId,
        },
        data: {
          "authorizer-principal-id": {
            user_type: 4,
            staff_id: this.staffId,
          },
          staff_id: this.staffId,
          search: "False",
          dr_name: "",
          dr_phone_no: "",
        },
      })
        .then((response) => {
          if (
            response?.data?.all_related_doctors &&
            response.data.all_related_doctors.length > 0
          ) {
            let doctorIds = response?.data?.all_related_doctors?.map(
              (data) => data.doctor_id
            );
            this.setState({ defaultDoctorIds: doctorIds });
            this.setState({ selectedDoctorIds: doctorIds });
            this.fetchAppoinmentHistory(doctorIds);
          }
        })
        .catch((err) => {
          C2CConsole.log(
            "error in doctor list staff/get-complete-staff-info",
            err
          );
        });
    }
    if (this.clinicId) {
      afterLoginApiAxios
        .get("clinic/get-clinic-doctors", {
          headers: {
            Authorization: this.tokenId,
          },
          params: {
            clinic_id: this.clinicId,
          },
        })
        .then((res) => {
          let doctorIds = res?.data?.doctor_list?.map((data) => data.doctor_id);
          this.setState({ defaultDoctorIds: doctorIds });
          this.setState({ selectedDoctorIds: doctorIds });
          this.fetchAppoinmentHistory(doctorIds);
        });
    } else {
      this.setState({
        defaultDoctorIds: [this.state.appointmentDetails.doctor_id],
      });
      this.setState({
        selectedDoctorIds: [this.state.appointmentDetails.doctor_id],
      });
      this.fetchAppoinmentHistory([this.state.appointmentDetails.doctor_id]);
    }
  };

  fetchAppoinmentHistory = (doctor_ids) => {
    this.setState({ appointmentDatas: [] });
    let data = {
      patient_name: this.state.appointmentDetails.patient_name,
      patient_id: this.state.appointmentDetails.patient_id,
      phone_no: this.state.appointmentDetails?.phone_no
        ? this.state.appointmentDetails?.phone_no?.slice(3)
        : this.state.appointmentDetails?.patient_phone?.slice(3),
      appointment_filter: this.state.appointment_filter,
      consultation_filter: this.state.consultation_filter,
      start_date: this.state.startDate,
      end_date: this.state.endDate,
      mark_check_in_start_date: this.state.markCheckInStartDate,
      mark_check_in_end_date: this.state.markCheckInEndDate,
      page_number: this.state.page_number,
      rows_per_page: 10,
      patient_account_id: this.state.appointmentDetails.patient_account_id,
      doctor_ids:
        this.doctorRole === "consultant"
          ? [this.userId]
          : doctor_ids ?? this.state.selectedDoctorIds,
    };
    this.apiCall(data);
  };

  apiCall = (data) => {
    this.setState({ loading: true });
    let api_url = "/doctor/patient-history-rev3";
    if (this.clinicId) {
      api_url = "/clinic/patient-history-rev1";
      data["clinic_id"] = this.clinicId;
    }
    afterLoginApiAxios({
      method: "post",
      url: api_url,
      headers: {
        authorization: this.tokenId,
      },
      data: data,
    })
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == 200) {
          if (response.data.statusCode === 200) {
            this.setState({ appointmentDatas: response.data.data });
            this.setState({ page_number: response.data.page_number });
            this.setState({ records_per_page: response.data.records_per_page });
            this.setState({ total_entries: response.data.total_entries });
            this.setState({
              total_pages_count: response.data.total_pages_count,
            });
            this.setState({ loading: false });
          }
        }
      })
      .catch((e) => {
        this.setState({ loading: false });
      });
  };

  viewDocumentAction(appointment) {
    this.setState(
      {
        appointmentForDrawer: {
          app_id: { ...appointment, id: appointment.appointment_id },
        },
      },
      () => {
        this.setState({
          drawerOpen: true,
          drawerType: "View Documents",
        });
      }
    );
  }

  viewDetailsAction(appointment) {
    this.setState(
      {
        appointmentForDrawer: {
          app_id: { ...appointment, id: appointment.appointment_id },
        },
      },
      () => {
        this.setState({
          drawerOpen: true,
          drawerType: "Appointment Details",
        });
      }
    );
  }

  toggleDrawer() {
    this.setState({
      drawerOpen: !this.state.drawerOpen,
      drawerType: "",
      appointmentForDrawer: null,
    });
  }

  renderDocument(width) {
    if (this.state.documentShow) {
      return (
        <DocumentCotainer
          cancelHandler={() => this.closeNotification()}
          fullViewHandler={() =>
            this.setState({ fullView: !this.state.fullView })
          }
          url={this.state.fileURL}
          fileName={this.state.fileName}
          fileType={this.state.fileType}
          width={width || ""}
        />
      );
    }
  }

  closeNotification = () => {
    this.setState({
      documentShow: false,
      fullView: false,
      fileName: "",
      fileURL: "",
      fileType: "",
    });
  };

  viewDocument = ({ fileURL, fileName, fileType }) => {
    if (fileType && fileType.match(/pdf/gim)) {
      this.downloadURI(fileURL, fileName);
    } else {
      this.setState({
        documentShow: true,
        fileURL: fileURL,
        fileName: fileName,
        fileType: fileType,
      });
    }
  };

  downloadURI = (uri, name) => {
    let link = document.createElement("a");
    link.href = uri;
    link.target = "_blank";
    link.click();
  };

  viewPrescriptionAction = (appointment) => {
    this.setState(
      {
        appointmentForDrawer: {
          app_id: { ...appointment, id: appointment.appointment_id },
        },
      },
      () => {
        this.setState({
          viewPrescription: true,
          setLgShow: true,
        });
      }
    );
  };

  sendReminderAction = (appointment) => {
    this.setState(
      {
        appointmentForDrawer: {
          app_id: { ...appointment, id: appointment.appointment_id },
        },
      },
      () => {
        this.setState({
          setLgShow: true,
        });
      }
    );
  };

  downloadPrescriptionAction = (appointment) => {
    afterLoginApiAxios
      .post(
        "/patient/prescription-pdf",
        {
          appointment_id: appointment.appointment_id,
        },
        {
          headers: {
            Authorization: this.tokenId,
          },
        }
      )
      .then((response) => {
        const presDate = moment(appointment.appointment_date).format(
          "DD MMM YYYY"
        );
        const linkSource = `data:application/pdf;base64,${response.data.pdf_blob}`;
        const downloadLink = document.createElement("a");
        const fileName = `Prescription_${presDate}.pdf`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch(function (error) {
        swal({
          title: "OOPS",
          text: "Prescription could not be downloaded",
          icon: "warning",
        });
      });
  };

  successAction = () => {
    this.setState({
      setLgShow: false,
      appointmentForDrawer: null,
    });
  };

  cancelAction = () => {
    this.setState({
      setLgShow: false,
      appointmentForDrawer: null,
    });
  };

  viewAppointments = (type) => {
    if (type === "initial") {
      this.setState({
        appointments: this.state.appointmentsTemp?.slice(0, 5),
        activeDropDown: type,
      });
    } else if (type === "followUp") {
      const appts = this.state.appointmentsTemp.filter(
        (item) => !(item.is_follow_up === "False")
      );
      this.setState({
        appointments: appts?.slice(0, 5),
        activeDropDown: type,
      });
    } else if (type === "dateLatestToOldest") {
      let appt = JSON.parse(
        JSON.stringify(this.state.appointmentsTemp?.slice(0, 5))
      );
      appt = appt.sort(
        (a, b) =>
          new Date(
            moment(new Date(b.appointment_date + " " + b.start_time)).format(
              "MMM DD, YYYY, hh:mm A"
            )
          ) -
          new Date(
            moment(new Date(a.appointment_date + " " + a.start_time)).format(
              "MMM DD, YYYY, hh:mm A"
            )
          )
      );
      this.setState({
        appointments: appt,
        activeDropDown: type,
      });
    } else if (type === "dateOldestToLatest") {
      let appt = JSON.parse(JSON.stringify(this.state.appointments));
      appt = appt.sort(
        (a, b) =>
          new Date(
            moment(new Date(a.appointment_date + " " + a.start_time)).format(
              "MMM DD, YYYY, hh:mm A"
            )
          ) -
          new Date(
            moment(new Date(b.appointment_date + " " + b.start_time)).format(
              "MMM DD, YYYY, hh:mm A"
            )
          )
      );
      this.setState({
        appointments: appt,
        activeDropDown: type,
      });
    }
  };

  onRenderPopUp() {
    return (
      <span>
        {this.state.drawerOpen && (
          <div
            className={`px-0 ${
              !(isMobile || isTablet) &&
              "previous-patients-prescription-edit-drawer"
            } `}
          >
            <h2 className="ml-3 mr-3 mt-2">
              <span className="drawer-heading">{this.state.drawerType}</span>
              <span
                className="float-right cursor-pointer mt-2"
                onClick={this.toggleDrawer.bind(this)}
                style={{ fontSize: "1rem" }}
              >
                Close <i className="fa fa-times" aria-hidden="true"></i>
              </span>
            </h2>
            {this.state.drawerType === "View Documents" ? (
              <DocumentDoctor
                appointmentData={this.state.appointmentForDrawer}
                documentShow={this.state.documentShow}
                actions={{
                  viewDocumentAction: this.viewDocument.bind(this),
                }}
              >
                {this.renderDocument("98%")}
              </DocumentDoctor>
            ) : (
              <PatientDetail
                appointmentData={this.state.appointmentForDrawer}
              />
            )}
          </div>
        )}
      </span>
    );
  }

  // kundan

  renderAppointmentType = (appointmentType) => {
    switch (appointmentType) {
      case "in-clinic":
        return <span>In-Clinic</span>;
      case "online":
        return <span>Online</span>;
      default:
        return "";
    }
  };

  renderConsultationType = (
    appointmentType,
    consultationType,
    procedureName
  ) => {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (appointmentType) {
      case "online":
        if (consultationType === "instant") {
          return <span>Instant</span>;
        }
        if (consultationType === "followup") {
          return <span>{appointmentTypeText + " Follow-Up"}</span>;
        }
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        return <span>{procedureName}</span>;
      case "in-clinic":
        if (consultationType === "procedure") {
          return <span>{procedureName}</span>;
        }
        return <span>{appointmentTypeText + " Consultation"}</span>;
      case "instant":
        return <span>Instant</span>;
      default:
        return "";
    }
  };

  handleViewDocumentClick = (selectedAppointment) => {
    this.setState({
      appointmentForDrawer: {
        app_id: {
          id: selectedAppointment.appointment_id,
        },
        patientId: selectedAppointment.patient_id,
        patient_dob: selectedAppointment.patient_dob,
        patient_name: selectedAppointment.patient_name,
        patient_phone_no: selectedAppointment.patient_phone_no,
      },
    });
    this.setState({ drawerOpen: true });
    this.setState({ drawerType: "View Documents" });
  };

  editPrescriptionAction = (appointment) => {
    let tempDate = new Date();
    let yr = tempDate.getFullYear();
    let age = yr - Number(appointment.patient_dob.substring(0, 4));

    this.setState({
      appointmentForDrawer: {
        app_id: {
          id: appointment.appointment_id,
        },
        ageForDrawer: age,
        patientId: appointment.patient_id,
        patientAccountId: appointment.patient_account_id,
        patient_dob: appointment.patient_dob,
        patient_name: appointment.patient_name,
        patient_phone_no: appointment.patient_phone_no,
        doctor_id: appointment?.doctor_id,
      },
    });

    this.setState({ drawerOpen: true });
    this.setState({ drawerType: "Edit Prescription" });
  };

  rescheduleAppointmentAction = (appointment) => {
    this.setState({ appointment: appointment });
    this.setState({ showRescheduleModal: true });
  };
  cancelAppointmentAction = (appointment) => {
    this.setState({ appointment: appointment });
    this.setState({ showCancellationModal: true });
  };

  raiseInvoiceAction = (appointment) => {
    this.setState({ appointment: appointment });
    this.setState({ showRaiseInvoiceModal: true });
  };

  markNoShowAction = (appointment) => {
    this.setState({ appointment: appointment });
    this.setState({ showMarkNoShowModal: true });
  };

  handleDrawerToggle = () => {
    this.setState({ drawerOpen: false });
    this.refreshAppointments();
  };

  handleJoinCallClick = (appointment) => {
    afterLoginApiAxios
      .post(
        "/doctor/check-for-appointment",
        { doctor_id: this.userId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.tokenId,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data.statusCode === 200) {
            this.setState({ appointment: appointment });

            //Check for ongoing appointment
            if (
              response.data.ongoing_appointment &&
              response.data.data.appointment_id !== appointment.appointment_id
            ) {
              this.setState({ ongoingAppointment: response.data.data });
              this.setState({ showCloseOngoingConsultModal: true });
            }
            // Check for upcoming scheduled appointment
            else if (response.data.upcoming_appointment) {
              this.setState({ scheduledAppointment: response.data.data });
              this.setState({ showAppointmentScheduledModal: true });
            } else if (this.clinicId === response?.data?.data?.clinic_id) {
              this.setState({ ongoingAppointment: response.data.data });
              this.setState({ showAppointmentScheduledModal: true });
            }
            // Join video call
            else {
              if (
                window?.location?.pathname &&
                window?.location?.pathname?.includes("video")
              ) {
                this.props?.handleTab && this.props.handleTab();
                return;
              } else {
                this.checkJoinAlert(appointment);
              }
            }
          } else {
            // TODO: Error handling and logging
          }
        } else {
          // TODO: Error handling and logging
        }
      })
      .catch((err) =>
        C2CConsole.log("error in doctor/check-for-appointment", err)
      );
  };

  checkJoinAlert(appointment) {
    afterLoginApiAxios
      .post(
        "/user/check-joining-alert",
        { meeting_id: appointment?.appointment_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.tokenId,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data?.statusCode === 200) {
            if (
              response.data?.data?.show_pop_up &&
              appointment?.appointment_status != "in progress"
            ) {
              this.setState({ showJoinAppointmentModal: true });
            } else {
              this.joinVideoCall(appointment);
            }
          } else {
            // TODO: Error handling and logging
            this.joinVideoCall(appointment);
          }
        } else {
          this.joinVideoCall(appointment);
        }
      })
      .catch((err) => C2CConsole.log("error in user/check-joining-alert", err));
  }

  joinVideoCall = (appointment) => {
    this.props.history.push({
      pathname:
        window?.location?.pathname &&
        window?.location?.pathname?.includes("clinic")
          ? "/clinic/video"
          : "/doctor/video",
      state: {
        app_id: {
          id: appointment.appointment_id,
          patient_id: appointment.patient_id,
          patient_account_id: appointment.patient_account_id,
          patient_name: appointment.patient_name,
          patient_dob: appointment.patient_dob,
          phone_no: appointment.patient_phone_no,
          patient_city: appointment.patient_city,
          first_name: appointment.doctor_first_name,
          last_name: appointment.doctor_last_name,
          degree: appointment.degree,
          appointment_date: appointment.appointment_date,
          appointment_end_date_time: appointment.appointment_end_date_time,
          appointment_start_date_time: appointment.appointment_start_date_time,
          start_time: appointment.appointment_start_time,
          end_time: appointment.appointment_end_time,
          doctor_id: this.userId,
          in_progress:
            appointment?.appointment_status === APPLICABLE_STATUS.IN_PROGRESS
              ? true
              : false,
        },
        is_audio: true,
        is_video: true,
      },
    });
  };

  viewAppointment = (appointment_id, status) => {
    this.setState({ appointmentStatus: status });
    this.setState({ setOpenView: true });
    this.setState({ appointment_id: appointment_id });
  };

  closeView = () => {
    this.setState({ setOpenView: false });
  };

  getStatus = (data) => {
    this.setState({ consultation_filter: data.value });
    setTimeout(() => {
      this.fetchAppoinmentHistory();
    }, 500);
  };

  getAppointmentStatus = (data) => {
    this.setState({ appointment_filter: data.value });
    setTimeout(() => {
      this.fetchAppoinmentHistory();
    }, 500);
  };

  handleConsultation = () => {
    this.setState({ consultation_filter: "all" });
    setTimeout(() => {
      this.fetchAppoinmentHistory();
    }, 500);
  };

  handleAppointmentStatus = () => {
    this.setState({ appointment_filter: "all" });
    setTimeout(() => {
      this.fetchAppoinmentHistory();
    }, 500);
  };

  resetFilter = () => {
    this.setState({ consultation_filter: "all" });
    this.setState({ appointment_filter: "all" });
    this.setState({ startDate: "" });
    this.setState({ endDate: "" });
    this.setState({ selectedDoctorIds: this.state.defaultDoctorIds });
    setTimeout(() => {
      this.fetchAppoinmentHistory();
    }, 500);
  };

  refreshAppointments = () => {
    this.fetchAppoinmentHistory();
  };

  setShowFilterComponent = () => {
    this.setState({ showFilterComponent: false });
  };

  onFilterSuccess = (filterData) => {
    this.setState({ consultation_filter: filterData.status });
    this.setState({ appointment_filter: filterData.appointmentStatus });
    this.setState({ selectedDoctor: filterData.doctorName });
    this.setShowFilterComponent();
    setTimeout(() => {
      this.fetchAppoinmentHistory([filterData.doctorName]);
    }, 500);
  };

  onResetFilter = (resetFilterData) => {
    this.setState({ consultation_filter: resetFilterData.status });
    this.setState({ appointment_filter: resetFilterData.appointmentStatus });
    this.setShowFilterComponent();
    setTimeout(() => {
      this.fetchAppoinmentHistory();
    }, 500);
  };

  setCurrentPages = (page) => {
    this.setState({ currentPage: page });
    this.setState({ page_number: page });
    setTimeout(() => {
      this.fetchAppoinmentHistory();
    }, 500);
  };

  getDates = (start, end) => {
    this.setState({
      startDate: moment(start).format("YYYY-MM-DD"),
      endDate: moment(end).format("YYYY-MM-DD"),
    });
    setTimeout(() => {
      this.fetchAppoinmentHistory();
    }, 500);
  };

  getDatesForMarkCheckIn = (start, end) => {
    this.setState({
      markCheckInStartDate: moment(start).format("YYYY-MM-DD"),
      markCheckInEndDate: moment(end).format("YYYY-MM-DD"),
    });
    setTimeout(() => {
      this.fetchAppoinmentHistory();
    }, 500);
  };

  getAllDoctorsRelatedData = (data) => {
    this.setState({ allDoctorsRelatedData: data });
    const doctor_ids =
      data.value === "all" ? this.state.defaultDoctorIds : [data.doctor_id];
    this.setState({ selectedDoctorIds: doctor_ids });
    setTimeout(() => {
      this.fetchAppoinmentHistory();
    }, 500);
  };

  render() {
    return (
      <div>
        <section className="pro-body-content mypatient_bg">
          <div className={`pro_doctor_video ${this.props.className}`}>
            {/* <div className="container-fluid"> */}
            {this.state.loading ? <Loader /> : null}
            <div className="row mb-3 my_appoint_heading">
              <div className="col-sm-12 col-lg-12 mobile_padding">
                <h3 className="p-0 m-0 display-flex ai-center">
                  <div className="heading-appt">
                    {this.props.heading
                      ? this.props.heading
                      : "My Appointments"}
                  </div>
                  <div className="ml-auto no_web">
                    <Dropdown
                      className="filter-border"
                      onClick={() =>
                        this.setState({ showFilterComponent: true })
                      }
                    >
                      <Dropdown.Toggle
                        style={{
                          background: "#ffffff",
                          border: "none",
                          margin: "0px",
                          fontSize: "19px",
                          color: "#2F2F2F",
                        }}
                      >
                        <i className="fa fa-filter" aria-hidden="true"></i>
                      </Dropdown.Toggle>
                    </Dropdown>
                  </div>
                </h3>
              </div>
            </div>
            <span className="card-Show">{this.props.children}</span>
            <>
              <div
                className={`cont-width-main table-scroll-style`}
                // ref={scrollRef}
              >
                <div
                  className="cont-width-main-body-appointment cont-width-main-body-appointment-mobile"
                  style={{ backgroundColor: "white", paddingTop: "6px" }}
                >
                  <div className="patient-row-header transaction-row-header align-items-center my-2 mx-0  p-2 text-uppercase d-md-flex d-none d-sm-none">
                    <div className=" created_at ">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div>
                          APPOINTMENT <br />
                          DATE & TIME
                        </div>
                        <img
                          className="appointment-calendar-icon"
                          src={CalendarIcon}
                          onClick={() => this.openDatePicker("date&time")}
                          alt="cal"
                        />
                      </div>
                    </div>

                    <div className=" mark_checkin_date_time ">
                      <div className="d-flex patient_name mt-2">
                        <p className="appointment-table-status-col">
                          Doctor Name
                        </p>
                        {checkPermission() && this.props.doctorFilterList && (
                          <Dropdown size="sm">
                            <Dropdown.Toggle
                              id="dropdownMenu2"
                              className="appointment-dropdown-toggle"
                            >
                              <img
                                className="appointment-calendar-icon"
                                src={newIcon}
                                alt="calender"
                              />
                            </Dropdown.Toggle>
                            {this.props.doctorFilterList && (
                              <Dropdown.Menu className="appointment-table-dropdown-menu">
                                {this.props.doctorFilterList?.map(
                                  (item, index) => (
                                    <Dropdown.Item
                                      onClick={() => {
                                        localStorage.setItem(
                                          "appointmentDoctorName",
                                          JSON.stringify(item)
                                        );
                                        this.getAllDoctorsRelatedData(item);
                                      }}
                                      className="appointment-dropdown-item d-flex text-label"
                                      key={index}
                                    >
                                      <i
                                        className={`fa fa-check mr-3 check-icon-filter ${
                                          this.state.allDoctorsRelatedData
                                            .value === item.value
                                            ? "activeTab"
                                            : ""
                                        }`}
                                        aria-hidden="true"
                                      ></i>
                                      {/* {item.name} */}

                                      {item.name.includes(".")
                                        ? item.name
                                        : item?.name
                                            ?.split(" ")
                                            .slice(0, 2)
                                            .join(".") +
                                          " " +
                                          item?.name
                                            ?.split(" ")
                                            .slice(2, 4)
                                            .join(" ")}
                                    </Dropdown.Item>
                                  )
                                )}
                              </Dropdown.Menu>
                            )}
                          </Dropdown>
                        )}
                      </div>
                    </div>

                    <div className=" mark_checkin_date_time ">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div>
                          MARK <br />
                          CHECK-IN
                        </div>
                      </div>
                    </div>
                    <div className=" mark_checkin_date_time ">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div>
                          CONSULTATION <br />
                          STARTED
                        </div>
                      </div>
                    </div>
                    <div className=" mark_checkin_date_time ">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div>
                          CONSULTATION <br />
                          ENDED
                        </div>
                      </div>
                    </div>
                    <div className=" d-flex consultation_type">
                      <p className="appointment-table-status-col">
                        Consultation
                      </p>
                      <Dropdown size="sm">
                        <Dropdown.Toggle
                          id="dropdownMenu2"
                          className="appointment-dropdown-toggle"
                        >
                          <img
                            className="appointment-calendar-icon"
                            src={newIcon}
                            alt=""
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="appointment-table-dropdown-menu">
                          {filters?.status?.map((item, index) => (
                            <Dropdown.Item
                              onClick={() => this.getStatus(item)}
                              className="appointment-dropdown-item d-flex text-label"
                              key={index}
                            >
                              <i
                                className={`fa fa-check mr-3 check-icon-filter ${
                                  this.state.consultation_filter === item.value
                                    ? "activeTab"
                                    : ""
                                }`}
                                aria-hidden="true"
                              ></i>
                              {item.name}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="appointment_status d-flex pr-0">
                      <p className="appointment-table-status-col">
                        Appointment Status
                      </p>
                      <Dropdown size="sm">
                        <Dropdown.Toggle
                          id="dropdownMenu2"
                          className="appointment-dropdown-toggle"
                        >
                          <img
                            className="appointment-calendar-icon ml-0"
                            src={newIcon}
                            alt=""
                          />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="appointment-table-dropdown-menu dropdown-scroll_style">
                          {this.state.filterValues.map((item, index) => (
                            <Dropdown.Item
                              onClick={() => this.getAppointmentStatus(item)}
                              className="appointment-dropdown-item d-flex text-label"
                              key={index}
                            >
                              <i
                                className={`fa fa-check mr-3 check-icon-filter ${
                                  this.state.appointment_filter == item.value
                                    ? "activeTab"
                                    : ""
                                }`}
                                aria-hidden="true"
                              ></i>
                              {item.name}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    {/* commented for 12950 ==> */}
                    {/* <div className=" paid_amount">Action</div> */}
                    {/* <== commented for 12950 */}
                  </div>
                  <div className="bg-white-card slected_patient_filter">
                    <SelectedPatientsFilter
                      selectedConsultation={this.state.consultation_filter}
                      selectedAppointmentStatus={this.state.appointment_filter}
                      handleConsultation={() => this.handleConsultation()}
                      handleAppointmentStatus={() =>
                        this.handleAppointmentStatus()
                      }
                      resetFilter={() => this.resetFilter()}
                    />
                  </div>
                  {this.state.appointmentDatas &&
                  this.state.appointmentDatas.length > 0 ? (
                    <>
                      {this.state.appointmentDatas.map(
                        (appointmentData, index) => (
                          <AppointmentPatientRow
                            appointmentData={appointmentData}
                            index={index}
                            key={appointmentData?.appointment_id}
                            renderAppointmentType={this.renderAppointmentType}
                            renderConsultationType={this.renderConsultationType}
                            handleViewDocumentClick={
                              this.handleViewDocumentClick
                            }
                            viewAppointment={this.viewAppointment}
                            editPrescriptionAction={this.editPrescriptionAction}
                            rescheduleAppointmentAction={
                              this.rescheduleAppointmentAction
                            }
                            cancelAppointmentAction={
                              this.cancelAppointmentAction
                            }
                            raiseInvoiceAction={this.raiseInvoiceAction}
                            markNoShowAction={this.markNoShowAction}
                            handleJoinCallClick={this.handleJoinCallClick}
                            currentPage={this.state.currentPage}
                            refreshAppointments={this.refreshAppointments}
                          />
                        )
                      )}
                    </>
                  ) : (
                    <div
                      className="text-center d-flex flex-column justify-content-center bg-white"
                      style={{ height: 400 }}
                    >
                      <div className="">
                        <img src={NoDataFound} alt="no record" />
                      </div>
                      <div style={{ marginTop: 15 }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            fontSize: 15,
                            color: "#1B2027",
                            textAlign: "center",
                          }}
                        >
                          No Record Found
                        </span>
                      </div>
                      <span
                        style={{
                          fontSize: 12,
                          color: "#707070",
                          textAlign: "center",
                        }}
                      >
                        There are no appointments available
                      </span>
                    </div>
                  )}
                </div>
                <DrawerComponent
                  drawerOpen={this.state.drawerOpen}
                  toggleDrawer={this.handleDrawerToggle}
                  drawerType={this.state.drawerType}
                  appointmentForDrawer={this.state.appointmentForDrawer}
                  fetchPastAppointmentDataList={() => {
                    this.fetchAppoinmentHistory(this.state.defaultDoctorIds);
                  }}
                />
                <AppointmentJoinModal
                  appointment={this.state.appointment}
                  openView={this.state.showJoinAppointmentModal}
                  closeView={() => {
                    this.setState({ showJoinAppointmentModal: false });
                  }}
                  joinVideoCallback={() =>
                    this.joinVideoCall(this.state.appointment)
                  }
                />
                <RescheduleModal
                  appointment={this.state.appointment}
                  doctor_id={this.userId}
                  openView={this.state.showRescheduleModal}
                  closeView={() => {
                    this.setState({ showRescheduleModal: false });
                  }}
                  slugUrl={this.slugUrl}
                  refreshAppointmentsMethod={this.refreshAppointments}
                />
                <CancellationModal
                  appointment_id={this.state.appointment?.appointment_id}
                  openView={this.state.showCancellationModal}
                  closeView={() => {
                    this.setState({ showCancellationModal: false });
                  }}
                  refreshAppointmentsMethod={this.refreshAppointments}
                  fetchUpcomingAppointments={() => {
                    this.refreshAppointments();
                  }}
                />
                <MarkCheckInModal
                  appointment_id={this.state.appointment?.appointment_id}
                  patient_name={this.state.appointment?.patient_name}
                  appointment_date={this.state.appointment?.appointment_date}
                  appointment_start_time={
                    this.state.appointment?.appointment_start_time
                  }
                  appointment_end_time={
                    this.state.appointment?.appointment_end_time
                  }
                  openView={this.state.showRaiseInvoiceModal}
                  closeView={() => {
                    this.setState({ showRaiseInvoiceModal: false });
                  }}
                  refreshAppointmentsMethod={this.refreshAppointments}
                  reLoadWindows={() => {
                    window.location.reload();
                  }}
                />
                <MarkNoShowModal
                  appointment_id={this.state.appointment?.appointment_id}
                  openView={this.state.showMarkNoShowModal}
                  closeView={() => {
                    this.setState({ showMarkNoShowModal: false });
                  }}
                  refreshAppointmentsMethod={this.refreshAppointments}
                />
                <CloseOngoingConsultModal
                  appointment_id={this.state.ongoingAppointment.appointment_id}
                  patient_name={this.state.ongoingAppointment.patient_name}
                  consultation={this.renderConsultationType(
                    this.state.ongoingAppointment.appointment_type,
                    this.state.ongoingAppointment.consultation_type,
                    this.state.ongoingAppointment.procedure_name
                  )}
                  openView={this.state.showCloseOngoingConsultModal}
                  closeView={() => {
                    this.setState({ showCloseOngoingConsultModal: false });
                  }}
                  refreshAppointmentsMethod={this.refreshAppointments}
                  joinVideoCallback={() =>
                    this.joinVideoCall(this.state.appointment)
                  }
                />
                <AppointmentScheduledModal
                  appointment_id={
                    this.state.scheduledAppointment.appointment_id
                  }
                  patient_name={this.state.scheduledAppointment.patient_name}
                  appointment_start_time={
                    this.state.scheduledAppointment.appointment_start_time
                  }
                  appointment_end_time={
                    this.state.scheduledAppointment.appointment_end_time
                  }
                  openView={this.state.showAppointmentScheduledModal}
                  closeView={() => {
                    this.setState({ showAppointmentScheduledModal: false });
                  }}
                  refreshAppointmentsMethod={this.refreshAppointments}
                  joinVideoCallback={() =>
                    this.joinVideoCall(this.state.appointment)
                  }
                />
                {/* <ViewDetailsModal
                  openView={this.state.setOpenView}
                  closeView={this.closeView}
                  appointment_id={this.state.appointment_id}
                /> */}
              </div>
              {this.state.total_pages_count !== 1 ? (
                <div className="container-fluid pb-3 pt-4 m-0 doctor_pagination_container">
                  <Pagination
                    className="d-flex justify-content-end pagination_body"
                    currentPage={this.state.currentPage}
                    totalCount={this.state.total_entries}
                    pageSize={this.state.total_pages_count}
                    onPageChange={this.setCurrentPages}
                  />
                </div>
              ) : (
                ""
              )}
            </>
          </div>
        </section>

        {this.state.showFilterComponent && (
          <FilterPatientsModal
            appointmentStatus={this.state.appointment_filter}
            status={this.state.consultation_filter}
            onFilterSuccess={this.onFilterSuccess}
            onHandleMethodCall={this.onHandleMethodCall}
            show={this.state.showFilterComponent}
            handleClose={() => this.setShowFilterComponent()}
            onResetFilter={this.onResetFilter}
          />
        )}

        {this.state.show && (
          <AppointmentDateRangePicker
            fetchDates={(start, end) => {
              if (this.state.datePickerType === "date&time") {
                this.getDates(start, end);
              } else {
                this.getDatesForMarkCheckIn(start, end);
              }
            }}
            closeDatePicker={() => this.openDatePicker("")}
            class_name={"date_picker_patient"}
          />
        )}

        <ViewDetailsModalNew
          openView={this.state.setOpenView}
          closeView={this.closeView}
          appointment_id={this.state.appointment_id}
          appointmentStatus={this.state.appointmentStatus}
        />
      </div>
    );
  }
}

export default withRouter(AppointmentPatient);
